import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
// middlewares
// import AuthMiddleware from '../../../../reducers/auth/middleware';
import { Navigate } from 'react-router-dom';
import PostalCodeMiddleware from '../../../../middleware/modules/master/postalcode';
import PostalCode from '../../../../components/modules/master/postalcode';
import useScript from '../../../../components/utilities/useScript';

const mapStateToProps = ({ auth,postalcode }) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: auth.isProcessing,
  isRegistered: auth.isRegistered,
  isError: auth.isError,
  errorMessage: auth.errorMessage,
  datalist:postalcode.data
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    PostalCodeList: customer =>PostalCodeMiddleware.list(customer)
  }, dispatch);
};
class PostalCodeContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.object,
    datalist: PropTypes.object,
    PostalCodeList: PropTypes.func.isRequired
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: {}
  }
  componentWillMount() {
    var host=process.env.APP_URL
    const search = {
      limit: 10,
    };
   this.props.PostalCodeList(search);
  }
  render() {
    const { isAuthenticated, isProcessing, isRegistered, isError, errorMessage, PostalCodeList ,datalist} = this.props;
    // if(isAuthenticated){
    //   return <Navigate
    //         to='/'
    //       />
    // }
    return (
      <PostalCode 
        search={PostalCodeList}
        data={datalist}
        isProcessing={isProcessing}
        isError={isError}
        errorMessage={errorMessage}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PostalCodeContainer);
